import { UploadFile } from 'antd';

// Đơn có 2 bộ ảnh tách biệt:
// - 'tech': `images` — ảnh kỹ thuật/điều hành chụp khi thực hiện đơn (luồng cũ)
// - 'creator': `creatorImages` — ảnh người tạo đơn (staffCreate) đính kèm, ai cũng xem được
export type TOrderImageKind = 'tech' | 'creator';

export const ORDER_IMAGE_KIND_LABEL: Record<TOrderImageKind, string> = {
  tech: 'Ảnh kỹ thuật',
  creator: 'Ảnh người tạo đơn'
};

// Cờ gửi kèm body UploadImageOrder để BE lưu vào CreatorImages thay vì images.
// TODO: đối chiếu lại đúng tên field với BE
export const CREATOR_IMAGE_FLAG = 'isCreatorImages';

// Trạng thái đơn đã đóng: 4 = Hoàn tất, 5 = Huỷ (xem convertStatusTextToStatusClient trong utilOrder)
const CLOSED_STATUS_VALUES = ['4', '5'];

export const getOrderImagesRaw = (order: any, kind: TOrderImageKind): any[] => {
  if (!order) return [];
  if (kind === 'creator') return order.creatorImages ?? order.CreatorImages ?? [];
  return order.images ?? [];
};

export const toUploadFiles = (list: any[]): UploadFile[] =>
  (list || []).map(e => ({
    uid: e.id,
    name: e.comment,
    status: 'done',
    url: process.env.REACT_APP_URL_AUTH + e.link
  }));

// Chỉ người tạo đơn được thêm/sửa ảnh của mình, và chỉ khi đơn chưa Hoàn tất/Huỷ
export const canEditCreatorImages = (order: any, username?: string): boolean =>
  !!username &&
  !!order?.staffCreate &&
  order.staffCreate === username &&
  !CLOSED_STATUS_VALUES.includes(order?.status?.statusValue);
